module.exports = __webpack_public_path__ + "img/17851_S.c8cd571d.png";